import React from "react";
import PropTypes from "prop-types";
import { FormattedNumber } from "react-intl";

const propTypes = {
  number: PropTypes.number.isRequired,
  className: PropTypes.string,
  countryIso: PropTypes.string
};

const ConvertToMoney = ({ number, className = "", countryIso = "US" }) => {
  const neg = number < 0;
  const output = Math.abs(number) / 100.0;
  return (
    <div className={className}>
      {neg && "-"}
      <FormattedNumber value={output} style="currency" currency="USD" />
      {countryIso && countryIso !== "US" && <span>&nbsp;USD</span>}
    </div>
  );
};

ConvertToMoney.propTypes = propTypes;

export default ConvertToMoney;
